import { Injectable } from '@angular/core';
import { HttpApiService } from '../services/http-api.service';
import { AgentType } from './agent.service';

@Injectable({
  providedIn: 'root',
})
export class PreloadSystemService {
  constructor(private http: HttpApiService) { }

  getPreloadSystem() {
    return this.http.get<IPreloadSystem>(`api/core/ag/system-preload`);
  }
}

export interface IPreloadSystem {
  ip_address: IIpAddress;
  device: IDevice;
  game: IGame;
  currency: IPreCurrency[];
  agent_type: AgentType[];
  avatars: IAvatars[];
  provider: ProviderGame[];
  isActive: boolean;
  isMa: boolean;
}
export interface ProviderGame {
  id: number;
  game_provider: string;
  image: string;
  seamless: boolean;
  connected: boolean;
}
export interface IPreCurrency {
  currency: string;
  description: string;
  img_flag: string;
}
export interface IAvatars {
  path: string;
}

export interface IIpAddress {
  ipv4: string;
  ipv6: string;
  isBlacklist: boolean;
}

export interface IDevice {
  device_name: string;
  device_type: string;
  device_os: string;
  header: IHeader;
}

export interface IHeader {
  user_agent: string;
  origin: string;
  referer: string;
  host: string;
}

export interface IGame {
  game_type: string[];
  game_provider: IGameProvider[];
}

export interface IGameProvider {
  game_code: string;
  game_name: string;
  game_logo: string;
  game_type: string;
  seamless: boolean;
}

// export interface AgentType {
//   typeId: number
//   typeName: string
//   typeDetail: string
// }
